"use strict";

define(['marionette', 'components/avatar/index', './topicItemView', './../templates/index.html'], function (Marionette, AvatarComponent, TopicItemView, tmplLayoutTopic) {
  return Marionette.LayoutView.extend({
    tagName: 'li',
    template: tmplLayoutTopic,
    className: 'user flag flag--top',
    options: {
      avatarSize: 'm',
      showCategory: true
    },
    regions: {
      avatar: '.js-avatar',
      content: '.js-content'
    },
    onRender: function onRender() {
      this.getRegion('avatar').show(new AvatarComponent({
        user: this.model.get('lastPost').author,
        size: this.getOption('avatarSize')
      }));
      this.getRegion('content').show(new TopicItemView({
        model: this.model,
        showCategory: this.options.showCategory
      }));
    }
  });
});